import createNavTrackingClient from './createNavTrackingClient';
import events from 'unified-navigation-ui/events.yaml';
import { Logger } from 'simple-logging-lib';
import { UNIFIED_NAVIGATION_UI_LOGGER_NAME } from '../../constants/logging';
import { isJasmineRunning } from '../../utils/testEnv';
let NavUsageTracker;
function setupNavUsageTrackers(userEmail, navType) {
  if (NavUsageTracker) return;
  const usageTrackingClient = createNavTrackingClient(userEmail);

  // For events that won't trigger a page unload
  NavUsageTracker = usageTrackingClient.createTracker({
    events,
    properties: {
      namespace: 'nav-v4',
      navType
    },
    bypassPool: false
  });
}
function trackUsage(event, properties) {
  const logger = Logger.getLogger(UNIFIED_NAVIGATION_UI_LOGGER_NAME);
  if (!NavUsageTracker) {
    if (isJasmineRunning()) {
      return;
    }
    logger.error(new Error('NavUsageTracker not initialized'), {
      event,
      properties
    });
    return;
  }
  NavUsageTracker.track(event, properties);
}
export { setupNavUsageTrackers, trackUsage };